import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconCorrelationSchemeM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path
        d="M2.50001 1.5L6.04785 5.93301L12.5933 8.11483L3.13876 11.3876L14.5 13.5"
        strokeLinecap="round"
        fill="none"
        stroke="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.77925 3H0.5C0.223858 3 0 3.22386 0 3.5C0 3.77614 0.223858 4 0.5 4H2.57957L1.77925 3ZM4.00004 5.77488V9.50209L5.00004 9.15594V7.02438L4.87672 6.87028L4.00004 5.77488ZM12 6.33591V4H6.42205L5.62173 3L12 3V0.499994C12 0.223852 12.2238 -5.72205e-06 12.5 -5.72205e-06C12.7761 -5.72205e-06 13 0.223852 13 0.499994V3H15.5C15.7761 3 16 3.22386 16 3.5C16 3.77614 15.7761 4 15.5 4L13 4V6.66924L12 6.33591ZM9.25998 11H12V9.90754L13 9.56139V11H15.5C15.7761 11 16 11.2239 16 11.5C16 11.7761 15.7761 12 15.5 12H14.6382L9.25998 11ZM5.00004 13.2593L4.00004 13.0734V15.5C4.00005 15.7761 4.2239 16 4.50004 16C4.77619 16 5.00004 15.7761 5.00004 15.5V13.2593ZM5.00004 2.22321L5.00004 0.5C5.00004 0.223858 4.77619 0 4.50004 0C4.2239 0 4.00004 0.223858 4.00004 0.5V0.973718L5.00004 2.22321Z"
      />
    </svg>
  )
}

export const IconCorrelationScheme = createIcon({
  name: 'IconCorrelationScheme',
  l: IconCorrelationSchemeM,
  m: IconCorrelationSchemeM,
  s: IconCorrelationSchemeM,
  xs: IconCorrelationSchemeM,
})
